export const PROGRESS_RATIO = {
	sceneData: {start: 0, mult: 0.25},
	assets: {start: 0.25, mult: 0.0},
	nodes: {start: 0.25, mult: 0.75},
};
